import type { MarketplaceDisplayBadge } from '__generated__/zeus/types';

export function browseListingStatus(displayBadge: MarketplaceDisplayBadge) {
  switch (displayBadge) {
    case 'AVAILABLE_SOON':
      return 'coming-soon';
    case 'ON_THE_MARKET':
      return 'self-tour';
    case 'TRADITIONAL':
    case 'TEMPORARILY_UNAVAILABLE':
      return 'listed';
    default:
      return null;
  }
}

export function browseListingStatusLabel(displayBadge: MarketplaceDisplayBadge) {
  switch (browseListingStatus(displayBadge)) {
    case 'coming-soon':
      return 'Coming soon';
    case 'self-tour':
      return 'Self tour';
    case 'listed':
      return 'Listed';
    default:
      return null;
  }
}
